<template>
  <SlideOutContainerViaPortal :disableAnimation="disableAnimation" :loading="combinedLoading">
    <div
      class="container-fluid"
      style="padding-top: 17px;"
      v-if="show"
    >
    <!-- we need below  <div>p</div> to have proper layout on UI. Remove it when have oportunity to check and fix the layout without the element-->
    <div>p</div>
      <InvoiceEditLayout :isSecondaryLayout="!isDocumentPreviewPanelVisible">
        <template #left-column>
          <PageHeader showBreadcrumbs :customBreadcrumbs="breadcrumbs" :page-title="title" wrapperClassName="row">
            <template #onSideOfTitle>
              <PayoutStatus v-if="isHaveStatus" :status="data && data.payout_status" />
            </template>
          </PageHeader>
          <b-form class="form-generator row">
            <InvoiceFormCard>
              <PanelHeader title="Details" :isOpen="blocksShow.main" :onToggleButtonClick="toggleMainBlock" />

              <b-collapse v-model="blocksShow.main">
                <b-card-body class="pt-0 pb-1">

                  <div class="row">
                    <b-form-group class="col-6">
                      <label class="form__label">{{form.fields.contractor.label}}</label>
                      <multiselect ref="contractor" v-model="$v.form.fields.contractor.value.$model"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.contractor.value.$error) || getMainFormBackendError('contractor_id'),
                          'is-valid': shouldShowGreenBorder('contractor')
                        }" :options="getContractors"
                        :placeholder="form.fields.contractor.placeholder" :track-by="form.fields.contractor.valueField"
                        :label="form.fields.contractor.selectLabel"
                        :disabled="mode === 'edit' || !!form.fields.partner.value" :allow-empty="false"
                        :showLabels="false" @select="(selectedOption) => { selectPayee('contractor', selectedOption); clearMainFormBackendError('contractor_id'); }">
                        <template slot="clear">
                          <span class="material-icons clear-select" v-show="form.fields.contractor.value"
                            @click="clearSelect('contractor')">
                            close
                          </span>
                        </template>
                      </multiselect>
                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('contractor_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.contractor.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                    <b-form-group class="col-6">
                      <label class="form__label">{{form.fields.partner.label}}</label>
                      <multiselect ref="partner" v-model="$v.form.fields.partner.value.$model"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.partner.value.$error) || getMainFormBackendError('partner_id')
                        }" :options="getAllPartners"
                        :placeholder="form.fields.partner.placeholder" :track-by="form.fields.partner.valueField"
                        :label="form.fields.partner.selectLabel"
                        :disabled="mode === 'edit' || !!form.fields.contractor.value" :allow-empty="false"
                        :showLabels="false" @select="(selectedOption) => { selectPayee('partner', selectedOption); clearMainFormBackendError('partner_id'); }">
                        <template slot="clear">
                          <span class="material-icons clear-select" v-show="form.fields.partner.value"
                            @click="clearSelect('partner')">
                            close
                          </span>
                        </template>
                      </multiselect>
                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('partner_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.partner.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                  </div>

                  <div class="row">
                    <b-form-group class="col-6">
                      <label class="form__label">{{form.fields.contractor_bank_details.label}}
                        <span @click="fetchBankDetails()" class="ml-1" title="Refresh">
                          <font-awesome-icon icon="sync-alt" role="button" />
                        </span>
                        <span v-if="isFetchingBankDetails"
                          class="small-spinner spinner-border text-secondary fetch-bank-details-spinner" role="status">
                          <span class="sr-only">Loading...</span>
                        </span>
                      </label>

                      <multiselect ref="contractor_bank_details"
                        :value="$v.form.fields.contractor_bank_details.value.$model"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.contractor_bank_details.value.$error) || getMainFormBackendError('contractor_bank_details_id')
                        }"
                        @input="changePayeeBankDetails('contractor_bank_details', $event); clearMainFormBackendError('contractor_bank_details_id')"
                        :options="getContractorBankDetailsAvailable"
                        :placeholder="form.fields.contractor_bank_details.placeholder"
                        :track-by="form.fields.contractor_bank_details.valueField"
                        :label="form.fields.contractor_bank_details.selectLabel"
                        :disabled="!getContractorBankDetailsAvailable.length" :allow-empty="false"
                        :showLabels="false" />

                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('contractor_bank_details_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.contractor_bank_details.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                    <b-form-group class="col-6">
                      <label class="form__label">
                        {{form.fields.partner_bank_details.label}}
                        <span @click="fetchBankDetails()" class="ml-1" title="Refresh">
                          <font-awesome-icon icon="sync-alt" role="button" />
                        </span>
                        <span v-if="isFetchingBankDetails"
                          class="small-spinner spinner-border text-secondary fetch-bank-details-spinner" role="status">
                          <span class="sr-only">Loading...</span>
                        </span>
                      </label>

                      <multiselect ref="partner_bank_details" :value="form.fields.partner_bank_details.value"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.partner_bank_details.value.$error) || getMainFormBackendError('partner_bank_details_id')
                        }" @input="changePayeeBankDetails('partner_bank_details', $event); clearMainFormBackendError('partner_bank_details_id')"
                        :options="getPartnerBankDetailsAvailable"
                        :placeholder="form.fields.partner_bank_details.placeholder"
                        :track-by="form.fields.partner_bank_details.valueField"
                        :label="form.fields.partner_bank_details.selectLabel"
                        :disabled="!getPartnerBankDetailsAvailable.length || isCalculatingPayout" :allow-empty="false"
                        :showLabels="false" />

                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('partner_bank_details_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.partner_bank_details.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                  </div>

                  <b-form-group>
                    <label class="form__label">{{ form.fields.own_bank_details.label }}</label>
                    <multiselect v-model="$v.form.fields.own_bank_details.value.$model"
                      :class="{
                        'multiselect__single-line': true,
                        'is-invalid': (formSubmissionAttempted && $v.form.fields.own_bank_details.value.$error) || getMainFormBackendError('own_bank_details_id'),
                        'is-valid': shouldShowGreenBorder('own_bank_details')
                      }"
                      :options="form.fields.own_bank_details.options"
                      :placeholder="form.fields.own_bank_details.placeholder"
                      :track-by="form.fields.own_bank_details.valueField"
                      :label="form.fields.own_bank_details.selectLabel"
                      :disabled="form.fields.own_bank_details.disabled" :allow-empty="false" :showLabels="false"
                      @select="cachePreview; clearMainFormBackendError('own_bank_details_id')" />

                    <FieldErrorMessage
                      :backend-error="getMainFormBackendError('own_bank_details_id')"
                      :show-frontend-error="formSubmissionAttempted && $v.form.fields.own_bank_details.value.$error"
                      frontend-message="Field is required"
                    />
                  </b-form-group>

                  <div class="row">
                    <b-form-group class="col-12 col-lg-4">
                      <label class="form__label">{{ form.fields.payout_status.label }}</label>
                      <multiselect v-model="$v.form.fields.payout_status.value.$model"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.payout_status.value.$error) || getMainFormBackendError('payout_status_id')
                        }"
                        :options="form.fields.payout_status.options"
                        :placeholder="form.fields.payout_status.placeholder"
                        :track-by="form.fields.payout_status.valueField" :label="form.fields.payout_status.selectLabel"
                        :disabled="form.fields.payout_status.disabled" :allow-empty="false" :showLabels="false"
                        @select="clearMainFormBackendError('payout_status_id')" />

                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('payout_status_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.payout_status.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>

                    <b-form-group class="col-12 col-lg-4">
                      <label class="form__label">{{ form.fields.payout_template_type.label }}</label>
                      <multiselect :id="payoutTemplateTypeFieldId"
                        v-model="$v.form.fields.payout_template_type.value.$model"
                        :class="{
                          'multiselect__single-line': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.payout_template_type.value.$error) || getMainFormBackendError('payout_template_type_id')
                        }"
                        :options="form.fields.payout_template_type.options"
                        :placeholder="form.fields.payout_template_type.placeholder"
                        :track-by="form.fields.payout_template_type.valueField"
                        :label="form.fields.payout_template_type.selectLabel"
                        :disabled="form.fields.payout_template_type.disabled" :allow-empty="false" :showLabels="false"
                        @select="cachePreview; clearMainFormBackendError('payout_template_type_id')" />

                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('payout_template_type_id')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.payout_template_type.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>

                    <b-form-group v-if="!form.fields.custom_file.hidden" class="col-12 col-lg-4">
                      <label class="form__label">{{ form.fields.custom_file.label }}</label>
                      <div class="row">
                        <div class="col">
                          <CustomFile ref="customFile" v-model="$v.form.fields.custom_file.value.$model"
                            :placeholder="data && data.custom_file_name" :accept="customFilesAcceptedTypes" />
                        </div>
                      </div>
                    </b-form-group>
                  </div>

                  <b-form-group>
                    <label class="form__label">{{ form.fields.comment.label }}</label>
                    <b-form-input type="text" :placeholder="form.fields.comment.placeholder"
                      :class="{
                        'is-invalid': (formSubmissionAttempted && $v.form.fields.comment.value.$error) || getMainFormBackendError('comment'),
                        'is-valid': shouldShowGreenBorder('comment')
                      }"
                      :value="$v.form.fields.comment.value.$model" debounce="300" @keydown="keyDown"
                      @input="updateCommentField($event); cachePreview(); clearMainFormBackendError('comment')" />
                    <FieldErrorMessage
                      :backend-error="getMainFormBackendError('comment')"
                      :show-frontend-error="formSubmissionAttempted && $v.form.fields.comment.value.$error"
                      frontend-message="Field is required"
                    />
                  </b-form-group>

                  <div class="row">
                    <b-form-group :class="[form.fields.paid_date.hidden ? 'col-6' : 'col-12 col-lg-4']">
                      <label class="form__label">{{ form.fields.issue_date.label }}</label>
                      <Datepicker :bootstrap-styling="true" :disabledDates="form.fields.issue_date.disabledDates"
                        :placeholder="form.fields.issue_date.placeholder" :format="form.fields.issue_date.format"
                        :minimum-view="form.fields.issue_date.minimumView" :disabled="form.fields.issue_date.disabled"
                        :class="{
                          'datapicker': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.issue_date.value.$error) || getMainFormBackendError('issue_date')
                        }" :value="moment(form.fields.issue_date.value).toISOString()"
                        @input="$v.form.fields.issue_date.value.$model = _toLocalTime($event); cachePreview(); clearRelatedDateErrors('issue_date')" />
                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('issue_date')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.issue_date.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>

                    <b-form-group :class="[form.fields.paid_date.hidden ? 'col-6' : 'col-12 col-lg-4']">
                      <label class="form__label">{{ form.fields.due_date.label }}</label>
                      <Datepicker :bootstrap-styling="true" :disabledDates="form.fields.due_date.disabledDates"
                        :placeholder="form.fields.due_date.placeholder" :format="form.fields.due_date.format"
                        :minimum-view="form.fields.due_date.minimumView" :disabled="form.fields.due_date.disabled"
                        :class="{
                          'datapicker': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.due_date.value.$error) || getMainFormBackendError('due_date')
                        }" :value="moment(form.fields.due_date.value).toISOString()"
                        @input="$v.form.fields.due_date.value.$model = _toLocalTime($event); cachePreview(); clearRelatedDateErrors('due_date')" />
                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('due_date')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.due_date.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>

                    <b-form-group v-if="!form.fields.paid_date.hidden" class="col-12 col-lg-4">
                      <label class="form__label">{{ form.fields.paid_date.label }}</label>
                      <Datepicker :bootstrap-styling="true" :disabledDates="form.fields.paid_date.disabledDates"
                        :placeholder="form.fields.paid_date.placeholder" :format="form.fields.paid_date.format"
                        :minimum-view="form.fields.paid_date.minimumView" :disabled="form.fields.paid_date.disabled"
                        :class="{
                          'datapicker': true,
                          'is-invalid': (formSubmissionAttempted && $v.form.fields.paid_date.value.$error) || getMainFormBackendError('paid_date')
                        }" :value="moment(form.fields.paid_date.value).toISOString()"
                        @input="$v.form.fields.paid_date.value.$model = _toLocalTime($event); clearMainFormBackendError('paid_date')" />
                      <FieldErrorMessage
                        :backend-error="getMainFormBackendError('paid_date')"
                        :show-frontend-error="formSubmissionAttempted && $v.form.fields.paid_date.value.$error"
                        frontend-message="Field is required"
                      />
                    </b-form-group>
                  </div>
                </b-card-body>
              </b-collapse>
            </InvoiceFormCard>

            <InvoiceFormCard>
              <PanelHeader title="Items" :isOpen="blocksShow.items" :onToggleButtonClick="toggleItemsBlock" />

              <b-collapse v-model="blocksShow.items">
                <b-card-body class="pt-0 pb-1">

                  <b-form-group>
                    <label class="form__label">{{ form.fields.payout_type.label }}</label>
                    <multiselect v-model="$v.form.fields.payout_type.value.$model"
                      :class="{
                        'multiselect__single-line': true,
                        'is-invalid': (formSubmissionAttempted && $v.form.fields.payout_type.value.$error) || getMainFormBackendError('payout_type_id')
                      }"
                      :options="form.fields.payout_type.options" :placeholder="form.fields.payout_type.placeholder"
                      :track-by="form.fields.payout_type.valueField" :label="form.fields.payout_type.selectLabel"
                      :disabled="form.fields.payout_type.disabled" :allow-empty="false" :showLabels="false"
                      @select="cachePreview; clearMainFormBackendError('payout_type_id')" />

                    <FieldErrorMessage
                      :backend-error="getMainFormBackendError('payout_type_id')"
                      :show-frontend-error="formSubmissionAttempted && $v.form.fields.payout_type.value.$error"
                      frontend-message="Field is required"
                    />
                  </b-form-group>

                  <b-form-group>
                    <FinancePayoutsFormAutoFill ref="autoFill" :dates="form.fields.auto_fill.value"
                      :payout_id="form.fields.id.value" :contractor="getCurrentContractor" :partner="getCurrentPartner"
                      :currency_code="currentCurrencyCode" :currency_rate="form.fields.currency_rate.value"
                      @auto-fill="autoFillItems" @changeInterval="autoFillIntervalChanged" />
                  </b-form-group>

                </b-card-body>
              </b-collapse>

              <fragment
                v-if="form.fields.payout_type.value && form.fields.payout_type.value.id === config.payoutsTypes.by_time.id">
                <PanelDelimiter />

                <FinancesPayoutsCompanyItemsTable v-model="form.fields.items.value"
                  :$v-model="$v.form.fields.items.value" :current-contractor="getCurrentContractor"
                  :current-partner="getCurrentPartner" :current-choice="getChoice"
                  :formSubmissionAttempted="formSubmissionAttempted"
                  :backendErrors="backendErrors"
                  @calculateHours="calculateHours($event); cachePreview()"
                  @calculatePayout="calculatePayout(); cachePreview()"
                  @updateBackendErrors="backendErrors = $event" />
              </fragment>

              <PanelDelimiter />

              <FinancesPayoutsExtraPaymentsTable v-model="form.fields.extra_payments.value"
                :$v-model="$v.form.fields.extra_payments.value" :currencyCode="currentCurrencyCode"
                :kpiBonuses="form.fields.kpi_bonuses.value" :isCalculatingPayout="isCalculatingPayout"
                :addKpiBonus="addKpiBonus" @dataTouched="calculatePayout(); cachePreview()" />

              <fragment v-if="form.fields.taxes.value.length">
                <PanelDelimiter />

                <div class="position-relative">
                  <FinancesPayoutsTaxesTable v-model="form.fields.taxes.value" :$v-model="$v.form.fields.taxes.value"
                    :currencyCode="currentCurrencyCode" @calculatePayout="calculatePayout(); cachePreview()" />
                  <Preloader v-if="isCalculatingPayout" />
                </div>
              </fragment>
            </InvoiceFormCard>

            <InvoiceFormCard className="summary-container">
              <Preloader v-if="isCalculatingPayout" />

              <h5>Summary</h5>

              <div v-if="Object.values(form.fields.indicators.value).length">
                <div v-for="(items, indicator) in form.fields.indicators.value" :key="indicator">{{ indicator }}
                  <template v-if="indicator === 'OT'">(Over time: logged hours &gt; working hours)</template>
                  <template v-else-if="indicator === 'UT'">(Under time: logged hours &lt; working hours)</template>
                  <ul>
                    <li v-for="(hours, name) in items" :key="name">{{ name }} (logged: {{ hours.logged_hours }},
                      working: {{ hours.working_hours }})</li>
                  </ul>
                </div>
              </div>

              <b-form-group>
                <label class="form__label">Summary</label>
                <b-form-textarea id="textarea" v-model="form.fields.items_description.value" rows="3" max-rows="8"
                  readonly />
              </b-form-group>

              <b-form-group>
                <label class="form__label">{{ form.fields.currency_rate.label }}</label>
                <b-form-input v-model="$v.form.fields.currency_rate.value.$model"
                  :class="{
                    'currency-rate-input': true,
                    'is-invalid': (formSubmissionAttempted && $v.form.fields.currency_rate.value.$error) || getMainFormBackendError('currency_rate'),
                    'is-valid': shouldShowGreenBorder('currency_rate')
                  }"
                  :placeholder="form.fields.currency_rate.placeholder" :disabled="isCalculatingPayout"
                  :readonly="defaultCompensationCurrencyCode === currentCurrencyCode"
                  maxlength="7" type="number" step=".01" debounce="1000" @input="calculatePayout(); cachePreview(); clearMainFormBackendError('currency_rate')" />
                <span style="margin-left: 10px;">{{ currentCurrencyCode ? `${defaultCompensationCurrencyCode} /
                  ${currentCurrencyCode}` : ''}}</span>

                <FieldErrorMessage
                  :backend-error="getMainFormBackendError('currency_rate')"
                  :show-frontend-error="formSubmissionAttempted && $v.form.fields.currency_rate.value.$error"
                  frontend-message="Field is required"
                />
              </b-form-group>
            </InvoiceFormCard>
          </b-form>
        </template>
        <template #right-column>
          <PageHeader page-title="Preview PDF" wrapperClassName="d-flex" titleClassName="flex-grow-1" style="margin-bottom: 15px !important;">
            <template #buttons>
              <DocumentButtons>
                <DocumentButtonsGroup v-if="data && (data.payment_doc_url || data.download_url)">
                  <DownloadDocumentLink :href="data.download_url" tooltip="Download Payout" @download-click="showDownloadModal" ref="downloadButton" />
                  <PreviewDocumentLink :href="data.payment_doc_url" />
                </DocumentButtonsGroup>
                <TogglePreviewButton v-if="isDocumentPreviewAvailable" :value="isDocumentPreviewPanelVisible"
                  @input="toggleDocumentPreview()" />
                <CloseButton tooltip="Close form" :onClick="closeForm" />
              </DocumentButtons>
            </template>
          </PageHeader>

          <CollapsingContainer :isOpen="isDocumentPreviewPanelVisible"
            @onOpen="ui.isDocPreviewIframeReadyToBeDisplayed = true"
            @onHidden="ui.isDocPreviewIframeReadyToBeDisplayed = false">
            <DocumentPreview :isCustomTemplateTypeSelected="isCustomTemplateTypeSelected"
              :isLastUpdatePreviewRequestFailed="isLastUpdatePreviewRequestFailed"
              :uploadedFileName="uploadedCustomFileName" :attachedFileName="attachedCustomFileName"
              :attachedFileChanged="customFileChanged">
              <InvoiceFormCard v-if="isDocumentPreviewAvailable" :noBody="false">
                <DocumentPreviewIFrame
                  :enforceShowLoader="updatePreviewRequestScheduled || !ui.isDocPreviewIframeReadyToBeDisplayed"
                  :url="docPreviewUrl" iframeHeight="calc(100vh - 300px)" :toolbar="false" />
              </InvoiceFormCard>
            </DocumentPreview>
          </CollapsingContainer>

          <InvoiceFormCard>
            <div class="row p-3">
              <div class="col-md-7 d-flex align-items-center">
                <TotalAmount :isLoading="isCalculatingPayout"
                  :value="form.fields.amount.value ? form.fields.amount.value : 0"
                  :currencyCode="currentCurrencyCode" />
              </div>

              <div class="col-md-5">
                <b-button type="submit" @click="submit" class="button w-100 justify-content-center" variant="primary">
                  {{ data && data.id ? 'Save' : 'Create' }}
                </b-button>
              </div>
            </div>
          </InvoiceFormCard>
        </template>
      </InvoiceEditLayout>
    </div>
  </SlideOutContainerViaPortal>
</template>

<script>
import Moment from 'moment'
import { cloneDeep, debounce, uniqueId } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import Datepicker from 'vuejs-datepicker'
import { formValidators } from '@forms/constants'
import { DocumentPreviewMixin } from '@mixins/invoices/DocumentPreviewMixin'
import { DocumentPreviewViewMixin } from '@mixins/invoices/DocumentPreviewViewMixin'
import { InvoiceEditConfirmTabCloseMixin } from '@mixins/invoices/InvoiceEditConfirmTabCloseMixin'
import FieldErrorMessage from '@components/forms/FieldErrorMessage.vue'
import CustomFile from '@components/forms/CustomFile.vue'
import Preloader from '@components/Preloader'
import FinancesPayoutsCompanyItemsTable, { FieldNames as PayoutItemsFieldNames } from '@components/modals/FinancePayoutsForm/FinancesPayoutsCompanyItemsTable.vue'
import FinancePayoutsFormAutoFill from '@components/modals/FinancePayoutsForm/FinancePayoutsFormAutoFill'
import FinancesPayoutsExtraPaymentsTable from '@components/modals/FinancePayoutsForm/FinancesPayoutsExtraPaymentsTable.vue'
import FinancesPayoutsTaxesTable from '@components/modals/FinancePayoutsForm/FinancesPayoutsTaxesTable'
import SlideOutContainerViaPortal from '@components/transition/SlideOutContainerViaPortal.vue'
import CollapsingContainer from '@components/transition/CollapsingContainer.vue'
import PageHeader from '@components/PageHeader.vue'
import DocumentPreviewIFrame from '@components/invoices/DocumentPreviewIFrame.vue'
import DocumentPreview from '@components/invoices/DocumentPreview.vue'
import InvoiceEditLayout from '@components/invoices/InvoiceEditLayout.vue'
import PanelHeader from '@components/invoices/form/PanelHeader.vue'
import DocumentButtons from '@components/invoices/form/DocumentButtons.vue'
import DocumentButtonsGroup from '@components/invoices/form/DocumentButtonsGroup.vue'
import DownloadDocumentLink from '@components/invoices/form/DownloadDocumentLink.vue'
import PreviewDocumentLink from '@components/invoices/form/PreviewDocumentLink.vue'
import CloseButton from '@components/common/CloseButton.vue'
import InvoiceFormCard from '@components/invoices/form/InvoiceFormCard.vue'
import TotalAmount from '@components/invoices/form/TotalAmount.vue'
import PanelDelimiter from '@components/modals/FinanceInvoicesForm/components/PanelDelimiter.vue'
import TogglePreviewButton from '@components/invoices/form/TogglePreviewButton.vue'
import { CUSTOM_FILE_ACCEPTED_TYPES } from '@/constants/invoices'
import PayoutStatus from '@components/tables/elements/PayoutStatus'

export default {
  mixins: [
    validationMixin,
    DocumentPreviewMixin({
      updatePreviewCacheUrl: '/api/finances/payouts/cache-preview/'
    }),
    DocumentPreviewViewMixin,
    InvoiceEditConfirmTabCloseMixin
  ],
  components: {
    TogglePreviewButton,
    DocumentPreviewIFrame,
    DocumentPreview,
    InvoiceEditLayout,
    PanelDelimiter,
    Datepicker,
    PageHeader,
    PanelHeader,
    DocumentButtons,
    DocumentButtonsGroup,
    DownloadDocumentLink,
    PreviewDocumentLink,
    CloseButton,
    InvoiceFormCard,
    TotalAmount,
    SlideOutContainerViaPortal,
    CollapsingContainer,
    Preloader,
    FieldErrorMessage,
    CustomFile,
    FinancesPayoutsCompanyItemsTable,
    FinancesPayoutsExtraPaymentsTable,
    FinancesPayoutsTaxesTable,
    FinancePayoutsFormAutoFill,
    PayoutStatus
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    title: {
      type: String
    },
    value: {
      type: Boolean
    },
    data: {
      type: Object
    },
    disableAnimation: {
      type: Boolean,
      default: false
    },
    breadcrumbs: { type: Array, default: () => [] }
  },
  emits: ['close', 'loadingChange'],
  validations () {
    const validationRules = { form: { fields: {} } }

    for (let key in this.form.fields) {
      validationRules.form.fields[key] = {
        value: {}
      }

      // TODO get rid of this ugly approach. Stop using formValidators object. Use validators directly (like with validationNew approach).
      if (this.form.fields[key].validation) {
        this.form.fields[key].validation.map((validateItem) => {
          validationRules.form.fields[key].value[validateItem.name] = formValidators[validateItem.name](validateItem.params)
        })
      } else if (this.form.fields[key].validationNew) {
        validationRules.form.fields[key].value = this.form.fields[key].validationNew()
      }
    }

    return validationRules
  },
  data () {
    const that = this
    const defaultForm = {
      fields: {
        'id': {
          name: 'id',
          hidden: true
        },
        'contractor': {
          name: 'contractor_id',
          label: 'Contractors',
          selectLabel: 'label',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            {
              name: 'requiredIf',
              params: () => !that.form.fields.partner.value
            }
          ]
        },
        'partner': {
          name: 'partner_id',
          label: 'Partners',
          selectLabel: 'company_name',
          valueField: 'id',
          options: [],
          value: null
        },
        'contractor_bank_details': {
          name: 'contractor_bank_details_id',
          label: 'Contractor bank details',
          selectLabel: 'title',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            {
              name: 'requiredIf',
              params: () => !!that.form.fields.contractor.value
            }
          ]
        },
        'partner_bank_details': {
          name: 'partner_bank_details_id',
          label: 'Partner bank details',
          selectLabel: 'title',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            {
              name: 'requiredIf',
              params: () => !!that.form.fields.partner.value
            }
          ]
        },
        'own_bank_details': {
          name: 'own_bank_details_id',
          label: 'Own bank details',
          selectLabel: 'summary',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ]
        },
        'payout_status': {
          name: 'payout_status_id',
          label: 'Payout status',
          selectLabel: 'display_name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ]
        },
        'payout_template_type': {
          name: 'payout_template_type_id',
          label: 'Payout template type',
          selectLabel: 'display_name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ]
        },
        'custom_file': {
          name: 'custom_file',
          label: 'Custom doc file',
          value: null,
          hidden: true
        },
        'comment': {
          name: 'comment',
          label: 'Comment',
          placeholder: 'Comment',
          validation: [
            { name: 'required' }
          ],
          defaultValue: 'Software development and consulting for %dateFrom - %dateTo',
          edited: false,
          value: null
        },
        'comment_national': {
          name: 'comment_national',
          label: 'Comment national',
          placeholder: 'Comment National',
          validation: [
            { name: 'required' }
          ],
          defaultValue: 'Software development and consulting for %dateFrom - %dateTo',
          edited: false,
          value: null
        },
        'issue_date': {
          name: 'issue_date',
          label: 'Issue date',
          format: 'yyyy-MM-dd',
          placeholder: 'Issue Date',
          value: Moment().format('YYYY-MM-DD')
        },
        'due_date': {
          name: 'due_date',
          label: 'Due date',
          format: 'yyyy-MM-dd',
          placeholder: 'Due Date',
          value: null
        },
        'paid_date': {
          name: 'paid_date',
          label: 'Paid date',
          format: 'yyyy-MM-dd',
          placeholder: 'Paid Date',
          defaultValue: Moment().format('YYYY-MM-DD'),
          value: null,
          hidden: false
        },
        'payout_type': {
          type: 'select',
          name: 'payout_type_id',
          label: 'Payout type',
          selectLabel: 'type',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ]
        },
        'auto_fill': {
          name: 'auto_fill',
          label: 'Auto fill contractors (all items will be replaced)',
          value: {
            date_from: this._toLocalTime(Moment().subtract(1, 'months').startOf('month')),
            date_to: this._toLocalTime(Moment().subtract(1, 'months').endOf('month'))
          }
        },
        'items': {
          name: 'items',
          label: 'Payout items',
          value: null,
          validationNew: () => {
            const validation = {
              $each: Object.values(PayoutItemsFieldNames).reduce((acc, value) => {
                acc[value] = {}
                return acc
              }, {})
            }

            // Make field required only when Payout type set to "By time"
            if (this.form.fields.payout_type?.value?.id === 1) {
              validation.required = required
              validation.minLength = minLength(1)

              // Add required validation for specific fields that are needed for API validation
              validation.$each.project = { required }
              validation.$each.date_from = { required }
              validation.$each.date_to = { required }
            }

            return validation
          }
        },
        'kpi_bonuses': {
          name: 'kpi_bonuses',
          label: 'KPI',
          value: null
        },
        'extra_payments': {
          name: 'extra_payments',
          label: 'Extra payments',
          value: null,
          validation: [
            {
              name: 'requiredIf',
              params: () => that.form.fields.payout_type.value === that.types.find(el => el.type === 'Only extra payments')
            }
          ]
        },
        'taxes': {
          name: 'taxes',
          label: 'Taxes',
          value: []
        },
        'indicators': {
          value: {}
        },
        'items_description': {
          name: 'items_description',
          label: 'Items description',
          placeholder: 'Auto - generated description',
          value: null,
          validation: [
            { name: 'required' }
          ]
        },
        'currency_rate': {
          name: 'currency_rate',
          label: 'Currency rate',
          placeholder: 'Currency rate',
          value: ''
        },
        'amount': {
          name: 'amount',
          label: 'Amount',
          value: null
        }
      }
    }

    return {
      defaultForm,
      form: cloneDeep(defaultForm),
      currentPayoutType: 1,
      config: {
        payoutsTypes: {
          by_time: { id: 1 },
          only_extra_payments: { id: 2 }
        }
      },
      types: [
        { id: 1, type: 'By time' },
        { id: 2, type: 'Only extra payments' }
      ],
      defaultCompensationCurrencyCode: 'USD',
      isCalculatingPayout: false,
      calculatePayoutCancelToken: null,
      isFetchingBankDetails: false,
      internalLoading: false,
      loadingStartTime: null,
      minimumLoadingDuration: 1500,
      isInitializing: false,
      blocksShow: {
        main: true,
        items: true
      },
      formSubmissionAttempted: false,
      backendErrors: {},
      fieldsWithPreviousErrors: new Set(), // Track fields that have had validation errors
      // we have to generate payoutTemplateTypeFieldId dynamically because there can be multiple instances of FinancePayoutForm component on page and they should have different id's for payout template type select field
      payoutTemplateTypeFieldId: uniqueId('payout-template-type-select-field-'),
      customFileChanged: false,
      customFilesAcceptedTypes: CUSTOM_FILE_ACCEPTED_TYPES.join(', '),
      ui: {
        // This flag turns `true` when Invoice edit form opens and document preview panel is already visible,
        // or when user toggles document preview panel visibility and appear animation is finished.
        // We don't want to render iframe before Doc Preview panel animation is finished, because then document does
        // not fit the iframe width.
        isDocPreviewIframeReadyToBeDisplayed: false
      }
    }
  },
  computed: {
    ...mapGetters({
      getIsModalLoading: 'finances/getIsModalLoading',
      getAllUsers: 'getAllUsers',
      getAllPartners: 'partners/getAllPartners',
      getPayoutsStatuses: 'finances/getPayoutsStatuses',
      getPayoutsTemplateTypes: 'finances/getPayoutsTemplateTypes',
      getContractorBankDetails: 'finances/getContractorBankDetails',
      getPartnerBankDetails: 'finances/getPartnerBankDetails',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getPayoutsTypes: 'finances/getPayoutsTypes',
      getProjects: 'projects/getProjects'
    }),
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    combinedLoading () {
      return this.internalLoading || this.isCalculatingPayout
    },
    isHaveStatus () {
      return !!this.data?.payout_status
    },
    getContractors () {
      return this.$store.getters.getAllUsersWithTrashed.filter(user => {
        return user.partner_id === null
      })
    },
    getCurrentContractor () {
      return this.form.fields.contractor.value
    },
    getCurrentPartner () {
      return this.form.fields.partner.value
    },
    currentCurrencyCode () {
      if (this.form.fields.partner_bank_details.value) {
        return this.form.fields.partner_bank_details.value.currency.code
      }
      if (this.form.fields.contractor_bank_details.value) {
        return this.form.fields.contractor_bank_details.value.currency.code
      }
      return ''
    },
    getChoice () {
      if (this.form.fields.contractor.value) {
        return 'Contractor'
      } else if (this.form.fields.partner.value) {
        return 'Partner'
      }
      return ''
    },
    getContractorBankDetailsAvailable () {
      if (!this.getCurrentContractor) return []
      const currentContractorId = this.getCurrentContractor.id
      return this.getContractorBankDetails.filter(item => {
        return item.contractor_id === currentContractorId
      })
    },
    getPartnerBankDetailsAvailable () {
      if (!this.getCurrentPartner) return []
      const currentPartnerId = this.getCurrentPartner.id
      return this.getPartnerBankDetails.filter(item => {
        return item.partner_id === currentPartnerId
      })
    },
    moment () {
      return Moment
    },
    isCustomTemplateTypeSelected () {
      return this.form.fields.payout_template_type.value?.id === 3
    },
    uploadedCustomFileName () {
      return this.data?.custom_file_name
    },
    attachedCustomFileName () {
      return this.form.fields.custom_file.value?.name
    }
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        if (this.value) {
          this.onShowInit()
        } else {
          this.onHideCleanUp()
        }
      }
    },
    show (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.loadingStartTime = Date.now()
        this.isInitializing = true
        this.internalLoading = true
        this.$emit('loadingChange', true)
      }
    },
    combinedLoading (loading) {
      this.$emit('loadingChange', loading)
    },
    'data': {
      deep: true,
      handler (value) {
        this.setParamsForEdit(value)
        this.calculatePayout()

        // Check if we should stop loading after data is set
        setTimeout(() => {
          this.checkDataAndStopLoading()
        }, 100)
      }
    },
    'form.fields.payout_type.value': {
      deep: true,
      handler (value) {
        if (value.id === this.config.payoutsTypes.only_extra_payments.id) {
          this.calculatePayout()
          this.form.fields.items.value = null
        }
      }
    },
    'form.fields.payout_status': {
      deep: true,
      handler () {
        if (!this.form.fields.payout_status.value) {
          this.form.fields.paid_date.value = null
          return
        }
        this.form.fields.paid_date.hidden = this.form.fields.payout_status.value && this.form.fields.payout_status.value.name !== 'paid'
        if (this.form.fields.payout_status.value && this.form.fields.payout_status.value.name === 'paid') {
          this.form.fields.paid_date.value = this.form.fields.paid_date.value ? this.form.fields.paid_date.value : this.form.fields.paid_date.defaultValue
        } else {
          this.form.fields.paid_date.value = null
        }
      }
    },
    'form.fields.payout_template_type': {
      deep: true,
      handler (payoutTemplateType) {
        this.form.fields.custom_file.hidden = !(payoutTemplateType.value && payoutTemplateType.value.name === 'custom')
      }
    },
    'form.fields.custom_file.value': {
      handler (cur) {
        if (cur) {
          this.customFileChanged = true
        }
      }
    },
    backendErrors: {
      deep: true,
      handler (newErrors, oldErrors) {
        // Auto-focus on backend errors when they're set by parent
        if (newErrors && Object.keys(newErrors).length > 0) {
          this.trackFieldErrors() // Track which fields have backend errors
          if (!oldErrors || Object.keys(oldErrors).length === 0) {
            this.focusFirstErrorFieldFromBackend()
          }
        }
      }
    }
  },
  mounted () {
    this.setInitialForm()
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    onShowInit () {
      if (!this.data) {
        this.form = cloneDeep(this.defaultForm)
      }
      this.setInitialForm()
      this.ui.isDocPreviewIframeReadyToBeDisplayed = this.isDocumentPreviewPanelVisible
      this.resetDocumentPreview()
      // There are multiple instances of the FinancePayoutsForm components and they should synchronize they `isDocumentPreviewPanelVisible`.
      // That's why we need to read document preview visibility state from localStorage and set it to the component's state.
      this.restoreDocumentPreviewVisibilityStateFromLS()
    },
    onHideCleanUp () {
      this.$v.$reset()
      this.ui.isDocPreviewIframeReadyToBeDisplayed = false
      this.isCalculatingPayout = false
      if (this.calculatePayoutCancelToken) {
        this.calculatePayoutCancelToken.cancel()
      }
      // Clear backend errors and error tracking when form is closed
      this.clearAllBackendErrors()
    },
    setInitialForm () {
      this._toggleDataPageLoading(async () => {
        this.setAllOptions()

        // Trigger loading check after initial form setup
        setTimeout(() => {
          this.checkDataAndStopLoading()
        }, 100)
      })
    },
    setParamsForEdit (inData) {
      this.setBasePreviewUrl(inData?.payment_doc_url ?? null)

      if (!inData) return

      let data = cloneDeep(inData)

      this.form.fields.id.value = data.id
      if (data.contractor) {
        this.form.fields.contractor.value = data.contractor
        this.form.fields.contractor_bank_details.value = data.payee_bank_details
        this.form.fields.partner.value = null
        this.form.fields.partner_bank_details.value = null
      }
      if (data.partner) {
        this.form.fields.partner.value = data.partner
        this.form.fields.partner_bank_details.value = data.payee_bank_details
        this.form.fields.contractor.value = null
        this.form.fields.contractor_bank_details.value = null
      }
      this.form.fields.own_bank_details.value = data.own_bank_details
      this.form.fields.payout_status.value = data.payout_status
      this.form.fields.payout_template_type.value = this.preparePayoutTemplateType(data.payout_template_type)

      this.form.fields.comment.value = data.comment
      this.form.fields.comment.edited = true
      this.form.fields.comment_national.value = data.comment_national
      this.form.fields.comment_national.edited = true

      this.form.fields.issue_date.value = this._toLocalTime(data.issue_date)
      this.form.fields.due_date.value = this._toLocalTime(data.due_date)
      this.form.fields.paid_date.value = this._toLocalTime(data.paid_date)

      this.form.fields.payout_type.value = data.payout_type

      if (data.auto_fill) {
        this.form.fields.auto_fill.value = data.auto_fill
      }
      this.form.fields.items.value = this.prepareItems(data.contractors)
      this.form.fields.extra_payments.value = data.extra_payments
      this.form.fields.taxes.value = data.taxes.map(function (item) {
        item.is_manually_edit = !!item.is_manually_edit
        return item
      })
      this.form.fields.currency_rate.value = String(data.currency_rate)
      this.form.fields.items_description.value = data.items_description
      this.form.fields.amount.value = data.amount

      this.form.fields.indicators.value = {}
      this.form.fields.custom_file.value = null
    },
    prepareItems: items => items.map(item => {
      return {
        ...item,
        'date_from': Moment(item.date_from).format(),
        'date_to': Moment(item.date_to).format(),
        'contractor_id': item.contractor ? item.contractor.id : null,
        'contractor': item.contractor,
        'project_key': item.project ? item.project.key : null,
        'project': item.project,
        'calculateHours': true,
        'hoursCalculating': false
      }
    }),
    setAllOptions () {
      this.setPayoutsTypes()
      this.setPayoutsStatuses()
      this.customFileChanged = false // reset this flag
      this.form.fields.partner_bank_details.options = this.getPartnerBankDetails
      this.form.fields.contractor_bank_details.options = this.getContractorBankDetails
      this.form.fields.own_bank_details.options = this.getOwnBankDetails

      this.form.fields.comment.value = this.generateCommentText(this.form.fields.auto_fill.value, 'comment')
      this.form.fields.comment_national.value = this.generateCommentText(this.form.fields.auto_fill.value, 'comment_national')
      this.form.fields.custom_file.value = null

      this.setTemplates()
    },
    setTemplates () {
      this.form.fields.payout_template_type.options = this.getPayoutsTemplateTypes.map(item => {
        item = this.preparePayoutTemplateType(item)
        return item
      })
      if (!this.form.fields.payout_template_type.value) {
        this.form.fields.payout_template_type.value = this.getPayoutsTemplateTypes.find(el => el.name === 'giraffeteam_for_accountant')
      }
    },
    preparePayoutTemplateType (item) {
      item.display_name = item.name.charAt(0).toUpperCase() + item.name.slice(1).replaceAll('_', ' ')
      return item
    },
    setPayoutsTypes () {
      this.form.fields.payout_type.options = this.types
      if (!this.form.fields.payout_type || !this.form.fields.payout_type.value) {
        this.form.fields.payout_type.value = this.types.find(el => el.type === 'By time')
      }
    },
    setPayoutsStatuses () {
      this.form.fields.payout_status.options = this.getPayoutsStatuses
      if (!this.form.fields.payout_status || !this.form.fields.payout_status.value) {
        this.form.fields.payout_status.value = this.getPayoutsStatuses.find(el => el.display_name === 'New')
      }
    },
    async submit () {
      this.formSubmissionAttempted = true
      const { isValid } = this.validateForm()

      if (!isValid) {
        this.trackFieldErrors() // Track which fields have errors
        this.focusFirstErrorField()
        return
      }

      if (this.hasNotValidItems()) {
        this.$snotify.error(
          'Please fill in all Contractor items marked with red',
          'Error',
          this.$store.state.snotify
        )
        // Scroll to the first invalid contractor field without focusing
        this.$nextTick(() => {
          const invalidContractorField = document.querySelector('.finances-payouts-items-table .is-invalid')
          if (invalidContractorField) {
            // Only scroll, don't focus to avoid UI disruption
            invalidContractorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
      if (this.isCalculatingPayout || this.hasNotValidItems()) return

      // Start loading state for form submission
      this.loadingStartTime = Date.now()
      this.internalLoading = true
      this.$emit('loadingChange', true)

      const data = this.prepareDataForRequest(this.form.fields)

      if (this.$refs['customFile'] && this.$refs['customFile'].value) {
        data['custom_file'] = await this.fileToBase64(this.$refs['customFile'].value)
      } else {
        data['custom_file'] = null
      }
      this.$emit('submit', data)
    },
    // Expose method for parent components to set backend errors
    handleBackendErrors (errors) {
      this.setBackendErrors(errors)
      this.focusFirstErrorFieldFromBackend()
    },
    clearAllBackendErrors () {
      this.backendErrors = {}
      this.fieldsWithPreviousErrors.clear() // Clear error tracking on form reset
      // Also clear error tracking in contractor table if it exists
      this.$nextTick(() => {
        const contractorTable = this.$children.find(child =>
          child.$options.name === 'FinancesPayoutsCompanyItemsTable' ||
          child.$vnode?.componentOptions?.tag === 'FinancesPayoutsCompanyItemsTable'
        )
        if (contractorTable && contractorTable.clearErrorTracking) {
          contractorTable.clearErrorTracking()
        }
      })
    },
    validateForm () {
      this.$v.$touch()

      return {
        isValid: !this.$v.$invalid
      }
    },
    calculatePayout: debounce(function () {
      this.calculatePayoutRequest()
    }, 1500),
    async calculatePayoutRequest () {
      const data = this.getPreparedDataForRequest()

      if (data.items) {
        data.items = data.items.filter(item => item.contractor_id && item.project_key && item.date_from && item.date_to)
      }

      if (
        this.isCalculatingPayout ||
        (!data.contractor_id && !data.partner_id) ||
        (data.contractor_id && !data.contractor_bank_details_id) ||
        (data.partner_id && !data.partner_bank_details_id)
      ) return

      if (this.calculatePayoutCancelToken) {
        this.calculatePayoutCancelToken.cancel()
      }
      this.calculatePayoutCancelToken = this.axios.CancelToken.source()

      this.isCalculatingPayout = true

      return this.axios.post(
        `/api/finances/payouts/calculate`,
        data,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          cancelToken: this.calculatePayoutCancelToken.token
        }
      ).then(({ data }) => {
        this.form.fields.amount.value = data.amount
        this.form.fields.items_description.value = data.items_description
        this.form.fields.taxes.value = data.taxes
        this.form.fields.kpi_bonuses.value = data.kpi_bonuses
        this.form.fields.indicators.value = data.indicators
        this.config.defaultCompensationCurrencyCode = data.default_compensation_currency_code

        if (data.default_compensation_currency_rate) {
          this.form.fields.currency_rate.value = data.default_compensation_currency_rate.toString()
        }
      }).finally(() => {
        this.isCalculatingPayout = false

        // Trigger loading check after calculation completes
        setTimeout(() => {
          this.checkDataAndStopLoading()
        }, 50)
      })
    },
    checkDataAndStopLoading () {
      // Only stop loading if we're not calculating and initialization is complete
      if (!this.isCalculatingPayout && this.isInitializing) {
        const elapsedTime = Date.now() - this.loadingStartTime
        const remainingTime = this.minimumLoadingDuration - elapsedTime

        if (remainingTime > 0) {
          // Wait for minimum loading duration before stopping
          setTimeout(() => {
            this.internalLoading = false
            this.isInitializing = false
            this.$emit('loadingChange', false)
          }, remainingTime)
        } else {
          // Minimum duration has passed, stop immediately
          this.internalLoading = false
          this.isInitializing = false
          this.$emit('loadingChange', false)
        }
      }
    },
    finishLoading () {
      // External method to force finish loading
      const elapsedTime = Date.now() - (this.loadingStartTime || Date.now())
      const remainingTime = this.minimumLoadingDuration - elapsedTime

      if (remainingTime > 0) {
        // Wait for minimum loading duration before stopping
        setTimeout(() => {
          this.internalLoading = false
          this.isInitializing = false
          this.$emit('loadingChange', false)
        }, remainingTime)
      } else {
        // Minimum duration has passed, stop immediately
        this.internalLoading = false
        this.isInitializing = false
        this.$emit('loadingChange', false)
      }
    },
    fetchPreFillPayoutData (contractorId, partnerId) {
      return this.axios.post('/api/finances/payouts/pre-fill-payout-data/',
        {
          contractor_id: contractorId,
          partner_id: partnerId
        },
        { headers: { Authorization: 'Bearer' + localStorage.getItem('access_token') } })
    },
    updateCommentField (value) {
      this.$v.form.fields.comment.value.$model = value
      this.form.fields.comment.edited = true
      this.$v.form.fields.comment_national.value.$model = value
      this.form.fields.comment_national.edited = true
    },
    clearSelect (fieldName) {
      this.$refs[fieldName].isOpen = false
      this.form.fields[fieldName].value = null
      this.form.fields[`${fieldName}_bank_details`].options = []
      this.form.fields[`${fieldName}_bank_details`].value = null
    },
    selectPayee (type, val) {
      this.form.fields.contractor_bank_details.value = null
      this.form.fields.partner_bank_details.value = null

      this.form.fields.items.value = []
      let contractorId = null
      let partnerId = null

      if (type === 'contractor') {
        contractorId = val.id
      } else if (type === 'partner') {
        partnerId = val.id
      }
      this.preFillPayoutData(contractorId, partnerId)
        .then(() => {
          this.$refs['autoFill'].autoFillRequest()
        })
    },
    async changePayeeBankDetails (formFieldName, $event) {
      if (this.currentCurrencyCode && this.currentCurrencyCode !== $event.currency.code) {
        const confirm = await this.$root.$confirm.open(
          'Change currency',
          'Are your sure you want to change currency from ' + this.currentCurrencyCode + ' to ' + $event.currency.code + '?' +
          '\n (currency rate will be reset)'
        )
        if (!confirm) return
        this.form.fields.currency_rate.value = null
        this.calculatePayout()
      }
      this.$v.form.fields[formFieldName].value.$model = $event

      const lastOwnBankDetails = this.getOwnBankDetails.filter(item => item.currency.code === $event.currency.code).sort((a, b) => a.id > b.id).slice(0, 1).pop()
      this.form.fields['own_bank_details'].value = lastOwnBankDetails
      this.cachePreview()
    },
    async preFillPayoutData (contractorId, partnerId) {
      this.setIsModalLoading(true)

      return this.fetchPreFillPayoutData(contractorId, partnerId)
        .then(({ data }) => {
          if (Object.keys(data).length > 0) {
            if (data.contractors.length) {
              const newDateFrom = data.contractors.reduce(
                (minDate, contractor) => minDate.isAfter(contractor.date_to, 'YYYY-MM-DD') ? Moment(contractor.date_to) : minDate,
                Moment(data.contractors[0].date_to)
              ).add(1, 'day')
              const newDateTo = cloneDeep(newDateFrom).add(1, 'months').format()

              data.auto_fill = {}
              data.auto_fill.date_from = newDateFrom.format()
              data.auto_fill.date_to = newDateTo

              data.contractors = []
            }
            this.setParamsForEdit(data)
            this.calculatePayout()

            this.form.fields.comment.edited = false
            this.form.fields.comment.value = this.generateCommentText(this.form.fields.auto_fill.value, 'comment')
            this.form.fields.comment_national.edited = false
            this.form.fields.comment_national.value = this.generateCommentText(this.form.fields.auto_fill.value, 'comment_national')
          }
        })
        .catch(console.error)
        .finally(() => {
          this.setIsModalLoading(false)
        })
    },
    calculateHours: debounce(function ({ item, previousItem, index }) {
      if (item.contractor && item.project && item.date_from && item.date_to) {
        item.hoursCalculating = true

        this.axios.post('/api/working-time/working-hours-for-payouts',
          {
            'user_id': item.contractor.id,
            'project_key': item.project.key,
            'time_offs_settings_id': item.project.time_offs_settings_id,
            'date_from': this._toLocalTime(item.date_from),
            'date_to': this._toLocalTime(item.date_to),
            'date_from_previous': this._toLocalTime(previousItem.date_from),
            'date_to_previous': this._toLocalTime(previousItem.date_to),
            'currency_code': this.currentCurrencyCode,
            'currency_rate': this.form.fields.currency_rate.value,
            'hours': item.hours
          },
          { headers: { Authorization: 'Bearer' + localStorage.getItem('access_token') } }
        )
          .then(({ data }) => {
            if (item.calculateHours) {
              item.hours = data.logged_hours
              item.hour_cost = data.hour_cost
            }
            item.payment_type = data.payment_type
            item.amount = data.amount
            item.compensation_currency_code = data.compensation_currency_code
            item.logged_hours = data.logged_hours
            item.isNotValid = false

            // Clear any backend errors for this item when API succeeds
            const clearedErrors = { ...this.backendErrors }
            Object.keys(clearedErrors).forEach(key => {
              if (key.startsWith(`items.${index}.`)) {
                delete clearedErrors[key]
              }
            })
            this.backendErrors = clearedErrors

            this.calculatePayout()
          })
          .catch(({ response }) => {
            const errors = response.data.errors

            // Map API errors to backend errors format for the specific item
            const mappedErrors = { ...this.backendErrors }
            Object.keys(errors).forEach(fieldName => {
              const errorKey = `items.${index}.${fieldName}`
              mappedErrors[errorKey] = errors[fieldName]
            })
            this.backendErrors = mappedErrors

            // Also show toast notifications
            const errorValues = Object.values(errors)
            for (var i = 0; i < errorValues.length; i++) {
              this.$snotify.error(
                errorValues[i][0],
                'Error',
                this.$store.state.snotify
              )
            }
            item.isNotValid = true
          })
          .finally(() => {
            item.hoursCalculating = false
          })
      }
    }, 1500),
    async autoFillItems (data, isUserInitiated) {
      if (isUserInitiated) {
        this.$v.form.fields.items.value.$model = [] // this is required to mark field dirty
      } else {
        this.form.fields.items.value = []
      }

      for (const i in data) {
        data[i].date_from = Moment(data[i].date_from).format()
        data[i].date_to = Moment(data[i].date_to).format()
        const item = {
          ...data[i],
          calculateHours: true,
          hoursCalculating: false
        }
        this.form.fields.items.value.push(item)
        if (item.hour_cost === 0) {
          await this.calculateHours({ item, previousItem: item })
        }
      }
      this.cachePreview()
      await this.calculatePayoutRequest()
    },
    getPreparedDataForRequest () {
      return this.prepareDataForRequest(this.form.fields)
    },
    prepareDataForRequest (fields) {
      let newFields = cloneDeep(fields)

      newFields.issue_date.value = this._toLocalTime(newFields.issue_date.value)
      newFields.due_date.value = this._toLocalTime(newFields.due_date.value)
      if (newFields.paid_date) {
        newFields.paid_date.value = this._toLocalTime(newFields.paid_date.value)
      }

      if (newFields.payout_type.value.id === this.config.payoutsTypes.only_extra_payments.id) {
        newFields.items.value = []
      }

      if (newFields.items.value) {
        newFields.items.value = newFields.items.value.map(item => {
          return {
            ...item,
            contractor_id: item.contractor ? item.contractor.id : null,
            project_key: item.project ? item.project.key : null,
            time_offs_settings_id: item.project ? item.project.time_offs_settings_id : null,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }
      if (newFields.taxes.value) {
        newFields.taxes.value = newFields.taxes.value.map(item => {
          return {
            'tax_type_id': item.tax_type ? item.tax_type.id : null,
            'user_id': item.user ? item.user.id : null,
            'amount': item.amount,
            'is_manually_edit': item.is_manually_edit,
            'description': item.description
          }
        })
      }
      return this.prepareFormFieldsForRequest(newFields)
    },
    prepareFormFieldsForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        data[name] = typeof value === 'object' && !(value instanceof Array) ? value[field['valueField']] : value
      }
      return data
    },
    async fetchBankDetails () {
      this.isFetchingBankDetails = true
      await this.$api.finances.getBankDetailsAll()
      this.isFetchingBankDetails = false
    },
    async closeForm () {
      if (this.$v.form.fields.$anyDirty) {
        const confirm = await this.$root.$confirm.open(
          'Data not saved',
          'Are you sure you want to close without saving?',
          { submitText: 'Close' }
        )
        if (!confirm) return
      }

      this.show = false
      this.$emit('close')
    },
    autoFillIntervalChanged (dates) {
      if (!this.form.fields.comment.edited) {
        this.form.fields.comment.value = this.generateCommentText(dates, 'comment')
      }
      if (!this.form.fields.comment_national.edited) {
        this.form.fields.comment_national.value = this.generateCommentText(dates, 'comment_national')
      }
    },
    generateCommentText (dates, field = 'comment') {
      const autoFillDateFrom = this._toLocalTime(dates.date_from, 'MMM DD YYYY')
      const autoFillDateTo = this._toLocalTime(dates.date_to, 'MMM DD YYYY')
      return this.form.fields[field].defaultValue.replace('%dateFrom', autoFillDateFrom).replace('%dateTo', autoFillDateTo)
    },
    addKpiBonus (bonus) {
      this.form.fields.extra_payments.value.push({
        'cost': bonus,
        'description': 'KPI bonus'
      })
      this.cachePreview()
      this.calculatePayout()
    },
    hasNotValidItems () {
      return this.form.fields.items.value && this.form.fields.items.value.filter(item => item.isNotValid === true).length > 0
    },
    setBackendErrors (errors) {
      this.backendErrors = this.mapBackendErrors(errors)
    },
    mapBackendErrors (errors) {
      const mappedErrors = {}

      // Map main form field errors
      Object.keys(errors).forEach(key => {
        if (key.includes('.')) {
          // Handle nested errors like items.0.project_key
          mappedErrors[key] = errors[key]
        } else {
          // Handle top-level form errors
          mappedErrors[key] = errors[key]
        }
      })

      return mappedErrors
    },
    clearMainFormBackendError (fieldName) {
      if (this.backendErrors[fieldName]) {
        const updatedErrors = { ...this.backendErrors }
        delete updatedErrors[fieldName]
        this.backendErrors = updatedErrors
      }
    },
    clearRelatedDateErrors (changedField) {
      // When issue_date or due_date changes, clear both fields' backend errors since they're related
      const relatedDateFields = ['issue_date', 'due_date']
      let hasChanges = false
      const updatedErrors = { ...this.backendErrors }

      relatedDateFields.forEach(fieldName => {
        if (this.backendErrors[fieldName]) {
          delete updatedErrors[fieldName]
          hasChanges = true
        }
      })

      if (hasChanges) {
        this.backendErrors = updatedErrors
      }
    },
    getMainFormBackendError (fieldName) {
      const error = this.backendErrors[fieldName]
      return error ? (Array.isArray(error) ? error[0] : error) : null
    },
    shouldShowGreenBorder (fieldName) {
      // Only show green border if the field had errors before and is now valid
      const hasError = (this.formSubmissionAttempted && this.$v.form.fields[fieldName]?.value?.$error) ||
                      this.getMainFormBackendError(this.getBackendFieldName(fieldName))
      const hadPreviousError = this.fieldsWithPreviousErrors.has(fieldName)
      const isDirty = this.$v.form.fields[fieldName]?.value?.$dirty

      return hadPreviousError && !hasError && isDirty && this.formSubmissionAttempted
    },
    getBackendFieldName (frontendFieldName) {
      // Convert frontend field names to backend field names for error checking
      const fieldMapping = {
        'contractor': 'contractor_id',
        'partner': 'partner_id',
        'contractor_bank_details': 'contractor_bank_details_id',
        'partner_bank_details': 'partner_bank_details_id',
        'own_bank_details': 'own_bank_details_id',
        'payout_status': 'payout_status_id',
        'payout_template_type': 'payout_template_type_id',
        'payout_type': 'payout_type_id',
        'comment': 'comment',
        'issue_date': 'issue_date',
        'due_date': 'due_date',
        'paid_date': 'paid_date',
        'currency_rate': 'currency_rate'
      }
      return fieldMapping[frontendFieldName] || frontendFieldName
    },
    trackFieldErrors () {
      // Track which fields currently have errors
      const fieldNames = [
        'contractor', 'partner', 'contractor_bank_details', 'partner_bank_details',
        'own_bank_details', 'payout_status', 'payout_template_type', 'comment',
        'issue_date', 'due_date', 'paid_date', 'payout_type', 'currency_rate'
      ]

      fieldNames.forEach(fieldName => {
        const hasError = (this.formSubmissionAttempted && this.$v.form.fields[fieldName]?.value?.$error) ||
                        this.getMainFormBackendError(this.getBackendFieldName(fieldName))

        if (hasError) {
          this.fieldsWithPreviousErrors.add(fieldName)
        }
      })
    },
    toggleMainBlock (event) {
      event.preventDefault()
      this.blocksShow.main = !this.blocksShow.main
    },
    toggleItemsBlock (event) {
      event.preventDefault()
      this.blocksShow.items = !this.blocksShow.items
    },
    keyDown (event) {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.submit()
      }
    },
    cachePreview (selectedOption, id) {
      if (this.mode === 'create') {
        return
      }

      if (id !== this.payoutTemplateTypeFieldId && this.form.fields.payout_template_type.value.id === 3) {
        // Do not update document preview when 'custom' (id === 3) payout template type is selected, unless user changes the payout_template_type field itself.
        // We don't need to update document preview for 'custom' payout template type, since for this type users upload file themselves, and it's not generated on the server.
        return
      }

      this.updatePreviewRequestScheduled = true
      this.cachePreviewDebounced()
    },
    cachePreviewDebounced: debounce(function () {
      const data = this.getPreparedDataForRequest()
      this.updateDocPreview(data)
    }, 2000),
    updateDocPreview (docData) {
      // Override the mixin's updateDocPreview to add backend validation error handling
      docData['preview'] = true
      this.isLastUpdatePreviewRequestFailed = false

      if (this.updateRequestCancelToken) {
        this.updateRequestCancelToken.cancel('Obsolete "document preview update" request canceled')
      }
      this.updateRequestCancelToken = this.axios.CancelToken.source()

      const docPreviewVersion = this.docPreviewVersion + 1
      const updatePreviewCacheUrl = '/api/finances/payouts/cache-preview/'

      this.axios
        .post(updatePreviewCacheUrl + docPreviewVersion, docData, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          cancelToken: this.updateRequestCancelToken.token
        })
        .then(() => {
          this.docPreviewVersion = docPreviewVersion
        })
        .catch(err => {
          if (this.axios.isCancel(err)) {
            return
          }

          console.error(err)
          this.isLastUpdatePreviewRequestFailed = true

          // Handle backend validation errors from cache-preview request
          if (err.response?.data?.errors) {
            // Set backend validation errors for form display
            this.backendErrors = { ...this.backendErrors, ...err.response.data.errors }
            this.trackFieldErrors() // Track which fields have backend errors
            this.focusFirstErrorFieldFromBackend()

            // Show single validation message instead of listing all errors
            this.$snotify.error(
              'The form is not valid. Please fill all required fields with valid data.',
              'Validation Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.updatePreviewRequestScheduled = false
        })
    },
    focusFirstErrorField () {
      this.$nextTick(() => {
        // Define the order of main form fields to check first
        const mainFieldOrder = [
          'contractor',
          'partner',
          'contractor_bank_details',
          'partner_bank_details',
          'own_bank_details',
          'payout_status',
          'payout_template_type',
          'comment',
          'issue_date',
          'due_date',
          'paid_date',
          'payout_type',
          'currency_rate'
        ]

        // Check main form fields first - prioritize these over table fields
        for (const fieldName of mainFieldOrder) {
          const field = this.$v.form.fields[fieldName]
          const hasError = field && field.value.$error

          if (hasError) {
            const focused = this.focusField(fieldName)
            if (focused) {
              return
            }
          }
        }

        // Only check table fields if NO main form fields have errors
        let hasMainFormErrors = false
        for (const fieldName of mainFieldOrder) {
          if (this.$v.form.fields[fieldName] && this.$v.form.fields[fieldName].value.$error) {
            hasMainFormErrors = true
            break
          }
        }

        // Check table validation errors only after main form
        if (!hasMainFormErrors && this.$v.form.fields.items && this.$v.form.fields.items.value.$error) {
          const invalidContractorField = document.querySelector('.finances-payouts-items-table .is-invalid')
          if (invalidContractorField) {
            // Only scroll, don't focus to avoid UI disruption
            invalidContractorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      })
    },
    focusField (fieldName) {
      // For multiselect fields, find them by form structure
      if (['contractor', 'partner', 'contractor_bank_details', 'partner_bank_details', 'own_bank_details', 'payout_status', 'payout_template_type', 'payout_type'].includes(fieldName)) {
        // Find the form group containing the label text for this field
        const labels = document.querySelectorAll('.form__label')

        for (const label of labels) {
          const labelText = label.textContent.toLowerCase()
          let expectedText = ''

          // Match expected text for each field type
          switch (fieldName) {
            case 'contractor':
              expectedText = 'contractor'
              break
            case 'partner':
              expectedText = 'partner'
              break
            case 'contractor_bank_details':
              expectedText = 'contractor bank details'
              break
            case 'partner_bank_details':
              expectedText = 'partner bank details'
              break
            case 'own_bank_details':
              expectedText = 'company bank details'
              break
            case 'payout_status':
              expectedText = 'status'
              break
            case 'payout_template_type':
              expectedText = 'template type'
              break
            case 'payout_type':
              expectedText = 'payout type'
              break
          }

          if (labelText.includes(expectedText)) {
            const formGroup = label.closest('.form-group') || label.closest('b-form-group')
            if (formGroup) {
              const multiselect = formGroup.querySelector('.multiselect')
              if (multiselect) {
                const input = multiselect.querySelector('input')
                if (input) {
                  input.focus()
                }
                multiselect.scrollIntoView({ behavior: 'smooth', block: 'center' })
                return true
              }
            }
          }
        }
      }

      // For comment field
      if (fieldName === 'comment') {
        const input = document.querySelector(`input.is-invalid[type="text"]`)
        if (input) {
          input.focus()
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For datepicker fields
      if (['issue_date', 'due_date', 'paid_date'].includes(fieldName)) {
        const datepicker = document.querySelector('.vdp-datepicker.is-invalid input')
        if (datepicker) {
          datepicker.focus()
          datepicker.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For currency rate field
      if (fieldName === 'currency_rate') {
        const input = document.querySelector('.currency-rate-input.is-invalid')
        if (input) {
          input.focus()
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      return false
    },
    scrollToField (fieldName) {
      // Scroll to field without focusing - for multiselect fields, find them by form structure
      if (['contractor', 'partner', 'contractor_bank_details', 'partner_bank_details', 'own_bank_details', 'payout_status', 'payout_template_type', 'payout_type'].includes(fieldName)) {
        // Find the form group containing the label text for this field
        const labels = document.querySelectorAll('.form__label')

        for (const label of labels) {
          const labelText = label.textContent.toLowerCase()
          let expectedText = ''

          // Match expected text for each field type
          switch (fieldName) {
            case 'contractor':
              expectedText = 'contractor'
              break
            case 'partner':
              expectedText = 'partner'
              break
            case 'contractor_bank_details':
              expectedText = 'contractor bank details'
              break
            case 'partner_bank_details':
              expectedText = 'partner bank details'
              break
            case 'own_bank_details':
              expectedText = 'company bank details'
              break
            case 'payout_status':
              expectedText = 'status'
              break
            case 'payout_template_type':
              expectedText = 'template type'
              break
            case 'payout_type':
              expectedText = 'payout type'
              break
          }

          if (labelText.includes(expectedText)) {
            const formGroup = label.closest('.form-group') || label.closest('b-form-group')
            if (formGroup) {
              const multiselect = formGroup.querySelector('.multiselect')
              if (multiselect) {
                // Only scroll into view, no focus
                multiselect.scrollIntoView({ behavior: 'smooth', block: 'center' })
                return true
              }
            }
          }
        }
      }

      // For comment field
      if (fieldName === 'comment') {
        const input = document.querySelector(`input.is-invalid[type="text"]`)
        if (input) {
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For datepicker fields
      if (['issue_date', 'due_date', 'paid_date'].includes(fieldName)) {
        const datepicker = document.querySelector('.vdp-datepicker.is-invalid input')
        if (datepicker) {
          datepicker.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      // For currency rate field
      if (fieldName === 'currency_rate') {
        const input = document.querySelector('.currency-rate-input.is-invalid')
        if (input) {
          input.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return true
        }
      }

      return false
    },
    focusFirstErrorFieldFromBackend () {
      // Scroll to first field with backend errors without focusing, to avoid UI focus disruption
      this.$nextTick(() => {
        const mainFieldOrder = [
          'contractor_id',
          'partner_id',
          'contractor_bank_details_id',
          'partner_bank_details_id',
          'own_bank_details_id',
          'payout_status_id',
          'payout_template_type_id',
          'comment',
          'issue_date',
          'due_date',
          'paid_date',
          'payout_type_id',
          'currency_rate'
        ]

        // Check main form fields first
        for (const fieldName of mainFieldOrder) {
          const hasBackendError = this.getMainFormBackendError(fieldName)
          if (hasBackendError) {
            const frontendFieldName = this.convertBackendToFrontendFieldName(fieldName)
            const scrolled = this.scrollToField(frontendFieldName)
            if (scrolled) {
              return
            }
          }
        }

        // Check table backend errors
        const contractorBackendErrors = Object.keys(this.backendErrors).filter(key => key.startsWith('items.'))
        if (contractorBackendErrors.length > 0) {
          const invalidContractorField = document.querySelector('.finances-payouts-items-table .is-invalid')
          if (invalidContractorField) {
            // Only scroll, don't focus
            invalidContractorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }
      })
    },
    convertBackendToFrontendFieldName (backendFieldName) {
      const fieldMapping = {
        'contractor_id': 'contractor',
        'partner_id': 'partner',
        'contractor_bank_details_id': 'contractor_bank_details',
        'partner_bank_details_id': 'partner_bank_details',
        'own_bank_details_id': 'own_bank_details',
        'payout_status_id': 'payout_status',
        'payout_template_type_id': 'payout_template_type',
        'payout_type_id': 'payout_type',
        'comment': 'comment',
        'issue_date': 'issue_date',
        'due_date': 'due_date',
        'paid_date': 'paid_date',
        'currency_rate': 'currency_rate'
      }
      return fieldMapping[backendFieldName] || backendFieldName
    },
    showDownloadModal () {
      // Create an enhanced data object with current form values
      const currentPayoutData = {
        ...this.data,
        // Override with current form value for template type
        payout_template_type: this.form.fields.payout_template_type.value
      }

      // Get the trigger element
      const triggerElement = this.$refs.downloadButton?.$el || null

      this.$emit('showDownloadModal', {
        payout: currentPayoutData,
        triggerElement
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loader {
  background-color: rgba($bgColorBase, 0.7);
}

.row {
  margin-right: -7px;
  margin-left: -7px;
}

.summary-container {
  padding: 1em calc(1em + 5px) 0.5em;

  .currency-rate-input {
    max-width: 157px;
    display: inline-block;
  }
}

// Validation styling for Datepicker component
:global(.vdp-datepicker.is-invalid input) {
  border-color: #DC3545 !important;
  background-image: none !important;
  padding-right: 12px !important;
}

:global(.vdp-datepicker.is-valid input) {
  border-color: #3FA52F !important;
  background-image: none !important;
  padding-right: 12px !important;
}
</style>
